import { useQuery } from "@apollo/client";
import type { Connection, ReadConnectionByCodeResult } from "@casey/db-types";
import { READ_CONNECTION_BY_CODE } from "../gql";

interface ReadConnectionByCodeVariables {
  connectionCode: string;
}

interface ReadConnectionByCodeResponse {
  readConnectionByCode: ReadConnectionByCodeResult | null;
}

export function useConnectionByCode(
  connectionCode: string,
  options: { skip?: boolean } = {},
) {
  const { data, loading, error, refetch } = useQuery<
    ReadConnectionByCodeResponse,
    ReadConnectionByCodeVariables
  >(READ_CONNECTION_BY_CODE, {
    variables: { connectionCode },
    skip: !connectionCode || options.skip,
    errorPolicy: "all",
    notifyOnNetworkStatusChange: true,
  });

  const result = data?.readConnectionByCode;

  return {
    connection: result?.connection || null,
    organizationSlug: result?.organizationSlug || null,
    organizationName: result?.organizationName || null,
    organizationAvatarUrl: result?.organizationAvatarUrl || null,
    greetingTitle: result?.greetingTitle || null,
    greetingBody: result?.greetingBody || null,
    loading,
    error,
    refetch,
  };
}

export type { Connection };

// Backwards compatibility
export { useConnectionByCode as useInviteByCode };
